export const AppFooter = () => (
  <footer className="tw:border-t tw:border-border tw:bg-neutral-50 tw:px-4 tw:py-4 tw:text-center tw:text-sm tw:text-muted-foreground">
    &copy; {new Date().getFullYear()} - Inspire Clean Energy
  </footer>
)
